import React, { useState } from 'react';
import { Title, Text, Modal, Button, Flex } from '@gjensidige/builders-components';

import './WelcomeBackModal.scss';
interface WelcomeBackModalProps {
  welcomeMessage: {
    header: string;
    message: string;
  },
  primaryBtnLabel?: string;
  primaryBtnAction?: () => void;
  closeLabel?: string;
  modalLabel?: string;
}
export const WelcomeBackModal: React.FC<WelcomeBackModalProps> = (
  props: WelcomeBackModalProps
) => {
  const [isOpen, setIsOpen] = useState(true);
  const onModalClose = (event?: any) => {
    event.preventDefault();
    setIsOpen(false);
  };
  const btnAction = () => {
    if (props.primaryBtnAction) {
      props.primaryBtnAction();
    }
    setIsOpen(false);
  }
  return (
    <Modal
      aria-label={props.modalLabel || "welcome-back-modal"}
      className="welcome-back-input-modal"
      open={isOpen}
      closeLabel={props.closeLabel || "Stäng"}
      strict={true}
      onClick={onModalClose}
      size="sm"
    >
      <div className="welcome-back-modal-wrapper pt-3">
        <Title as="h2" size="5">
          {props.welcomeMessage.header}
        </Title>
        <div className="pt-md-1 welcome-message">
          {
            props.welcomeMessage.message.split('\n').map((message, index) => (
              <Text key={index} size="body" className="">{message}</Text>
            ))
          }
        </div>
        {/* <Text size="body" className="pt-md-1 welcome-message">{props.welcomeMessage.message}</Text> */}
        {props.primaryBtnLabel && 
          <div className="welcome-back-footer">
            <Button
              variant="primary"
              onClick={btnAction}
            >
              {props.primaryBtnLabel}
            </Button>
          </div>
        }
      </div>
    </Modal>
  );
};
